// extracted by mini-css-extract-plugin
export default {"root":"more-options_root__nfClu","button":"more-options_button__dWH24","ball":"more-options_ball__JWIOt"};